var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { emailStringVerify } from '@@/Util';
import { Apphandler } from "@/ipc/MainAppHandler";
import { APPEvent } from "@/events/AppEvents";
import { BillStatus } from "@@/Quota";
export class SettingsUIStore {
    constructor() {
        this.spanels = [
            { type: 'details', label: 'Detail' },
            { type: 'license', label: 'License' },
            { type: 'storagelogs', label: 'Quota Changes Logs' },
            { type: 'payments', label: 'Payments' }
        ];
        this.selectedpanel = "details";
        this.loadingquota = false;
        this.loadingorgdetail = false;
        this.savingwatermark = false;
        this.edittingwarermark = false;
        this.loadingsetting = false;
        this.watermarktext = "";
        this.editcontactemail = false;
        this.logs = new Map();
        this.bills = new Map();
        this.loadingstoragelogs = false;
        this.loadingbill = false;
        this.hasmore = true;
        this.brandname = "";
        this.verified = false;
        this.contactemail = "";
        this.contactaddress = [];
        this.watermark = "";
        this.editemail = "";
        this.updatingemail = false;
        this.externalcontactpassword = "";
        this.externalcontacthint = "";
        this.showecpassword = false;
        this.showexternalcontactpassdialog = false;
        this.edithint = "";
        this.editecpassword = "";
        this.updatingecpass = false;
        this.activebillid = "";
        this.updatingaddress = false;
        this.lastlogtime = new Date().getTime();
        this.billreq = new Set();
        this.loadingstoragelogsmore = false;
        this.editaddress = "";
        this.edittingaddress = false;
        makeObservable(this);
        APPEvent.addSubscriberForStorageLogs((logs) => {
            logs.forEach((log) => this.addLog(log));
            if (logs.length < 100) {
                this.hasmore = false;
            }
            this.setLoadingLogsMore(false);
            this.setStorageLogsLoading(false);
        });
        APPEvent.addSubscriberForRecentBills((bills) => {
            bills.forEach((bill) => this.addBill(bill));
            this.setBillLoading(false);
        });
        APPEvent.addSubcriberForOrgDetails((ret) => {
            this.setLoadingOrgDetails(false);
            if (ret !== undefined) {
                this.setBrandName(ret.brandname);
                this.setContactEmail(ret.contactemail);
                this.setVerified(ret.verified);
                this.setWatermark(ret.watermark);
                this.setContactAddress(ret.address);
            }
        });
        APPEvent.addSubscriberForAdminUpdateWatermarkRes((ret) => {
            var _a;
            if (ret) {
                this.setSavingWatermark(false);
                this.setSavingWatermark(false);
            }
            (_a = this.onupdatewatermarkcb) === null || _a === void 0 ? void 0 : _a.call(this, ret);
        });
        APPEvent.addSubscriberForStartBill((bill) => {
            if (bill === null || bill === void 0 ? void 0 : bill.bill) {
                if (this.billreq.has(bill.bill.id)) {
                    if (bill.bill.status === BillStatus.Paid) {
                        this.addBill(bill.bill);
                        this.removeBillFromLoading(bill.bill.id);
                        return;
                    }
                    if (!bill.ordertoken) {
                        APPEvent.publishApperror("Sorry, failed to generate payment token. Please contact support at engineering@letrwing.com.");
                    }
                    else {
                        // now lets generate something!!
                        this.showDrop(bill.ordertoken, bill.bill.id);
                        this.setActiveBillId(bill.bill.id);
                    }
                    this.removeBillFromLoading(bill.billid);
                }
            }
            else if (bill) {
                if (this.billreq.has(bill === null || bill === void 0 ? void 0 : bill.billid)) {
                    APPEvent.publishApperror("Sorry, failed to generate payment token. Please contact support at engineering@letrwing.com.");
                    this.removeBillFromLoading(bill.billid);
                }
            }
        });
        APPEvent.addSubscriberForBillDone((done) => {
            if (done && this.billreq.has(done.id)) {
                this.addBill(done);
                this.removeBillFromLoading(done.id);
                if (done.status == BillStatus.Paid) {
                    APPEvent.publishApperror("Transcation completed successfully. Thanks v much");
                }
            }
        });
        APPEvent.addSubscriberForAdminUpdateContactEmailRes((ret) => {
            this.setContactAddress(ret.address);
            this.setContactEmail(ret.contactemail);
            if (this.updatingemail) {
                this.setUpdatingEmail(false);
                this.setEditContactEmail(false);
            }
            if (this.updatingaddress) {
                this.setUpdatingAddress(false);
                this.setEditAdress(false);
            }
        });
        APPEvent.addSubscriberForAdminGetLicenseInfoRes((ret) => {
            if (ret !== undefined) {
                this.quota = ret;
            }
            this.setLoadingQuota(false);
        });
    }
    setUpdatingAddress(upd) {
        this.updatingaddress = upd;
    }
    setEdittingAddress(add) {
        this.editaddress = add;
    }
    setEditAdress(edit) {
        this.edittingaddress = edit;
    }
    setActiveBillId(id) {
        this.activebillid = id;
    }
    showDrop(ordertoke, billid) {
        const dropConfig = {
            "components": [
                "order-details",
                "card",
                "upi",
                "app"
            ],
            "orderToken": ordertoke,
            "onSuccess": () => {
                this.checkPayment(billid);
            },
            "onFailure": (data) => {
                APPEvent.publishApperror("OOPS! payment was unsuccessful. Please try again.");
            },
            "style": {
                //to be replaced by the desired values
                "backgroundColor": "#ffffff",
                "color": "#11385b",
                "fontFamily": "Lato",
                "fontSize": "14px",
                "errorColor": "#ff0000",
                "theme": "light", //(or dark)
            }
        };
        const win = window;
        const cashfree = new win.Cashfree();
        const paymentElement = document.getElementById("payments");
        if (paymentElement) {
        }
        try {
            cashfree.initialiseDropin(paymentElement, dropConfig);
        }
        catch (err) {
            console.log(err);
        }
    }
    addHeader() {
    }
    addLog(log) {
        this.logs.set(log.id, log);
        if (this.lastlogtime > log.datetime) {
            this.lastlogtime = log.datetime;
        }
    }
    addBill(bill) {
        this.bills.set(bill.id, bill);
    }
    setShowEcPassword(show) {
        this.showecpassword = show;
    }
    setEditECPass(pass) {
        this.editecpassword = pass;
    }
    setLoadingLogsMore(loading) {
        this.loadingstoragelogsmore = loading;
    }
    setStorageLogsLoading(loading) {
        this.loadingstoragelogs = loading;
    }
    removeBillFromLoading(id) {
        this.billreq.delete(id);
    }
    checkPayment(id) {
        const req = id;
        this.billreq.add(id);
        Apphandler.sendMessage("billdone", req);
    }
    setBillLoading(loading) {
        this.loadingbill = loading;
    }
    setEditHint(hint) {
        this.edithint = hint;
    }
    setEditEmail(email) {
        this.editemail = email;
    }
    setUpdatingECPass(upd) {
        this.updatingecpass = upd;
    }
    setShowExternalECPassword(show) {
        this.showexternalcontactpassdialog = show;
    }
    setUpdatingEmail(updating) {
        this.updatingemail = updating;
    }
    startBillPayment(id) {
        this.billreq.add(id);
        Apphandler.sendMessage("startbill", id);
    }
    doneBillPayment(id) {
        this.billreq.add(id);
        Apphandler.sendMessage("billdone", id);
    }
    updateContactAddress() {
        this.setUpdatingAddress(true);
        const req = {
            email: this.contactemail,
            address: this.editaddress.split("\n")
        };
        Apphandler.sendMessage("adminupdatecontactemail", req);
    }
    updateContactEmail() {
        if (this.editemail && emailStringVerify(this.editemail)) {
            this.setUpdatingEmail(true);
            const req = {
                email: this.editemail,
                address: this.contactaddress
            };
            Apphandler.sendMessage("adminupdatecontactemail", req);
            // const ret = await SettingStore.updateContactEmail(this.editemail);
            // if(ret) {
            //     this.setContactEmail(this.editemail);
            // }
            // this.setUpdatingEmail(false);
            // return ret;
        }
    }
    async updateEcPassword() {
        if (this.editecpassword.trim().length >= 4) {
            this.setUpdatingECPass(true);
            // const ret = await SettingStore.updateExternalContactPassword(this.editecpassword, this.edithint);
            // if(ret) {
            //     this.updateExternalContactHint(this.edithint);
            //     this.updateExternalContactPassword(this.editecpassword);
            // }
            // this.setUpdatingECPass(false);
            // return ret;
        }
    }
    async updateWatermark() {
        if (this.watermarktext.trim()) {
            this.setSavingWatermark(true);
            const req = {
                watermark: this.watermarktext
            };
            Apphandler.sendMessage("adminupdatewatermark", req);
            // const wk = await SettingStore.addWatermark({watermark: this.watermarktext});
            // if(wk !== undefined) {
            //     this.setWatermark(wk.watermark);
            //     this.setSavingWatermark(false);
            //     return true;
            // }
            // this.setSavingWatermark(false);
        }
    }
    updateWatermarkText(text) {
        this.watermarktext = text;
    }
    updateExternalContactPassword(text) {
        this.externalcontactpassword = text;
    }
    updateExternalContactHint(text) {
        this.externalcontacthint = text;
    }
    setEdittingWatermark(editting) {
        this.edittingwarermark = editting;
    }
    setEditContactEmail(edit) {
        this.editcontactemail = edit;
    }
    setSelectedPanel(panel) {
        this.selectedpanel = panel;
    }
    setLoadingQuota(loading) {
        this.loadingquota = loading;
    }
    // public async getExternalContactPassword() {
    //     const pass = await SettingStore.getExternalContactDefaultPassword();
    //     if(pass !== undefined && pass.length > 1) {
    //         this.updateExternalContactPassword(pass[0]);
    //         this.updateExternalContactHint(pass[1]);
    //     }
    // }
    setLoadingOrgDetails(loading) {
        this.loadingorgdetail = loading;
    }
    setLoadingSetting(load) {
        this.loadingsetting = load;
    }
    setSavingWatermark(save) {
        this.savingwatermark = save;
    }
    async loadQuota() {
        this.setLoadingQuota(true);
        Apphandler.sendMessage("admingetlicenseinfo", "");
        // this.quota = await SettingStore.getQuota();
    }
    async loadOrgDetails() {
        this.setLoadingOrgDetails(true);
        Apphandler.sendMessage("admingetorgdetails", "");
        // await this.getExternalContactPassword();
        // this.setLoadingOrgDetails(false);
    }
    setBrandName(name) {
        this.brandname = name;
    }
    setVerified(verified) {
        this.verified = verified;
    }
    setContactEmail(email) {
        this.contactemail = email;
    }
    setContactAddress(add) {
        this.contactaddress = add;
    }
    setWatermark(mark) {
        this.watermark = mark;
    }
    loadMoreStorageLogs() {
        this.setLoadingLogsMore(true);
        const req = {
            startingtime: this.lastlogtime,
            totalcount: 100
        };
        Apphandler.sendMessage("storagelogs", req);
    }
    loadStorageLogs() {
        this.lastlogtime = new Date().getTime();
        this.logs.clear();
        const req = {
            startingtime: this.lastlogtime,
            totalcount: 100
        };
        this.setStorageLogsLoading(true);
        Apphandler.sendMessage("storagelogs", req);
    }
    loadbills() {
        this.bills.clear();
        this.setBillLoading(true);
        Apphandler.sendMessage("recentbills", "bills");
    }
    reset() {
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], SettingsUIStore.prototype, "selectedpanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "loadingquota", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "loadingorgdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "savingwatermark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "edittingwarermark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "loadingsetting", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "watermarktext", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "editcontactemail", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SettingsUIStore.prototype, "logs", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SettingsUIStore.prototype, "bills", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], SettingsUIStore.prototype, "loadingstoragelogs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "loadingbill", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "brandname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "verified", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "contactemail", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SettingsUIStore.prototype, "contactaddress", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "watermark", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "editemail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "updatingemail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "externalcontactpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "externalcontacthint", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "showecpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "showexternalcontactpassdialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "edithint", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "editecpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "updatingecpass", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "activebillid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "updatingaddress", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SettingsUIStore.prototype, "billreq", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "loadingstoragelogsmore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "editaddress", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SettingsUIStore.prototype, "edittingaddress", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setUpdatingAddress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setEdittingAddress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setEditAdress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setActiveBillId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "addLog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "addBill", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setShowEcPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setEditECPass", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setLoadingLogsMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setStorageLogsLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "removeBillFromLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "checkPayment", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setBillLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setEditHint", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setEditEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setUpdatingECPass", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setShowExternalECPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setUpdatingEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "startBillPayment", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "doneBillPayment", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "updateWatermarkText", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "updateExternalContactPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "updateExternalContactHint", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setEdittingWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setEditContactEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setSelectedPanel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setLoadingQuota", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setLoadingOrgDetails", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setLoadingSetting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setSavingWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setBrandName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setVerified", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setContactEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setContactAddress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "setWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "loadStorageLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SettingsUIStore.prototype, "loadbills", null);
